import { render, staticRenderFns } from "./Footbtn.vue?vue&type=template&id=44ff4c77&scoped=true&"
import script from "./Footbtn.vue?vue&type=script&lang=js&"
export * from "./Footbtn.vue?vue&type=script&lang=js&"
import style0 from "./Footbtn.vue?vue&type=style&index=0&id=44ff4c77&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ff4c77",
  null
  
)

export default component.exports